import {BlacklistPlayerProps, GeneralAction} from '../../../@types/actions';
import {ADD_TO_BLACKLIST} from '../../../constants/PlayerConstants';

export const BlacklistPlayerAction = (data: BlacklistPlayerProps): GeneralAction<BlacklistPlayerProps> => ({
    type: ADD_TO_BLACKLIST,
    payload: data
});
